export const DEFAULT_SYSTEM_GIFT_URL = 'https://t.me/yourbesrpresbot?startapp';

let systemGiftUrl = DEFAULT_SYSTEM_GIFT_URL;

export function setSystemGiftUrl(url?: string | null) {
  if (typeof url === 'string' && /^https?:\/\//i.test(url.trim())) systemGiftUrl = url.trim();
}

export function getSystemGiftUrl() {
  return systemGiftUrl;
}
